import { cx } from "@/utils/cx";

const TONES: Record<string, string> = {
	alertNow: "bg-brand-100 text-brand-800",
	applied: "bg-brand-50 text-brand-800",
	completed: "bg-brand-50 text-brand-800",
	confirmed: "bg-brand-50 text-brand-800",
	customerEdit: "bg-brand-100 text-brand-800",
	drafting: "border-secondary text-secondary border",
	escalate: "bg-brand-600 text-white",
	failed: "text-error-primary border-secondary border",
	forced: "text-warning-primary border-secondary border",
	lowPriorityLog: "border-secondary text-tertiary border",
	noChange: "border-secondary text-tertiary border",
	notConfirmed: "border-secondary text-tertiary border",
	pending: "border-secondary text-secondary border",
	queued: "border-secondary text-secondary border",
	rejected: "border-secondary text-tertiary border",
	reverted: "border-secondary text-tertiary border",
	reviewQueue: "border-secondary text-primary border",
	running: "border-secondary text-secondary border",
	skipped: "border-secondary text-tertiary border",
	superseded: "border-secondary text-tertiary border",
};

interface BadgeProps {
	/** Display text, when the raw value is not fit to show ("customerEdit"). */
	label?: string;
	value: string | undefined;
}

/**
 * Small pill for decisions and statuses; unknown values get the neutral
 * tone. The tone follows the value, whatever the label says.
 */
export const Badge = ({ label, value }: BadgeProps) => {
	if (!value) return <span className="text-tertiary">—</span>;
	return (
		<span
			className={cx(
				"inline-block rounded px-1.5 py-0.5 text-xs font-medium",
				TONES[value] ?? "border-secondary text-primary border",
			)}
		>
			{label ?? value}
		</span>
	);
};
